import { faImage } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import type { Editor } from '@tiptap/react'
import { type ReactElement, useRef } from 'react'

type ImageAddButtonProps = {
  editor: Editor | null
  className?: string
}

export const ImageAddButton = ({
  editor,
  className
}: ImageAddButtonProps): ReactElement => {
  const fileInput = useRef<HTMLInputElement>(null)

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const files = event.target.files
    if (!files || !editor) {
      return
    }

    editor.chain().focus().insertImageUploads(Array.from(files)).run()
    event.target.value = ''
  }

  return (
    <>
      <input
        type="file"
        hidden
        multiple
        ref={fileInput}
        accept="image/*"
        onChange={handleFileChange}
      />
      <button
        type="button"
        className={className}
        onClick={() => fileInput.current?.click()}
        disabled={!editor}
      >
        <FontAwesomeIcon icon={faImage} />
      </button>
    </>
  )
}
